import MapCanvas from './MapCanvas'

export default MapCanvas
